import PropTypes from 'prop-types'
import cn from '../modules/cn'

function TextInput({
  name,
  id,
  inline,
  small,
  leadingAddon,
  trailingAddon,
  className,
  ...props
}) {
  return (
    <div
      className="relative flex items-center"
    >
      {leadingAddon && (
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
          <div className="text-gray-500 text-sm">
            {leadingAddon}
          </div>
        </div>
      )}
      <input
        type="text"
        id={id || name}
        name={name}
        className={cn(
          'block w-full h-12 px-4 text-base focus:ring-theme-500 focus:border-theme-500',
          !inline && 'border-transparent focus:border-transparent rounded-full',
          leadingAddon && 'pl-8',
          trailingAddon && 'pr-8',
          inline && ['h-10 p-0 rounded-none border-0 border-b-2 focus:border-0 focus:border-b-2 focus:ring-0',
            'flex-1 border-gray-200 hover:border-gray-300'],
          small && 'h-9',
          className,
        )}
        {...props /* eslint-disable-line react/jsx-props-no-spreading */}
      />
      {trailingAddon && (
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
          <div className="text-gray-500 text-sm">
            {trailingAddon}
          </div>
        </div>
      )}
    </div>
  )
}

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  inline: PropTypes.bool,
  small: PropTypes.bool,
  leadingAddon: PropTypes.node,
  trailingAddon: PropTypes.node,
  className: cn.propType,
}

TextInput.defaultProps = {
  id: null,
  inline: false,
  small: false,
  leadingAddon: null,
  trailingAddon: null,
  className: null,
}

export default TextInput
